import { render, staticRenderFns } from "./LegalAccounting.vue?vue&type=template&id=2eea2de4&scoped=true&"
import script from "./LegalAccounting.vue?vue&type=script&lang=js&"
export * from "./LegalAccounting.vue?vue&type=script&lang=js&"
import style0 from "./LegalAccounting.vue?vue&type=style&index=0&id=2eea2de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea2de4",
  null
  
)

export default component.exports